export class PaymentInstallment {
    id = 0;
    title = '';
    installment = 1;
    percent = 0;
    type = 1;
}
